<template>
    <div class="llp-checkbox">
        <div class="py-1">
            <input :id="id" :checked="checked" :disabled="disabled" :name="name" class="form-check-input"
                   type="checkbox">
            <label :aria-label="ariaLabel" :class="classNames" :for="id" class="form-check-label px-2">
                <span v-if="isRequired" class="text-danger">* </span>
                <slot></slot>
            </label>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>
